export default __webpack_public_path__ + "static/media/Banner - Elevate Pro - Baby Blue.f4173dfa.jpg";